import { Tabs } from "antd";
import { useLocalStorage } from "react-use";

import { LegacyMetrics } from "./legacy-metrics/legacy-metrics";
import { IconicMetrics } from "./iconic-metrics/iconic-metrics";
import { Reports } from "./reports/reports";
import { useHasSalesRole } from "../../hooks/use-has-role";
import { useFlag } from "hooks/use-flag";

const customMetrics = {
  iconic: IconicMetrics,
};

export const DashboardRoute = () => {
  const [tab, setTab] = useLocalStorage(
    "LAYOUT_STATE.DASHBOARD.TAB",
    "metrics"
  );

  const hasSalesRole = useHasSalesRole();

  const Metrics = LegacyMetrics;

  const CustomMetrics =
    customMetrics[useFlag("dashboards:custom_metrics", "literal")];

  return (
    <div
      className="sm:w-full 2xl:max-w-[2048px]"
      style={{
        display: "grid",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "64px 1fr",
        height: "100%",
      }}
    >
      <Tabs
        activeKey={tab}
        onChange={setTab}
        tabBarStyle={{
          marginBottom: "0px",
          marginLeft: "24px",
        }}
        items={[
          {
            key: "metrics",
            label: "Metrics",
            children: null,
          },
          ...(CustomMetrics
            ? [
              {
                key: "custom_metrics",
                label: "Custom Metrics",
                children: null,
              },
            ]
            : []),
          ...(hasSalesRole
            ? [
              {
                key: "reports",
                label: "Reports",
                children: null,
              },
            ]
            : []),
        ]}
      />
      <div style={{ gridRowStart: 2, overflowY: "scroll" }}>
        {tab === "metrics" && <Metrics />}
        {tab === "custom_metrics" && CustomMetrics && <CustomMetrics />}
        {tab === "reports" && <Reports />}
      </div>
    </div>
  );
};
